module.exports = __webpack_public_path__ + "static/media/bg-board.658d447a.svg";